<div class="main-content">
  <div class="row">
    <!-- Header -->
    <div class="header-actions">
      <h4 class="card-title">Product List</h4>
      <div class="header-actions-buttons">
        <fh-refresh-button [onRefresh]="refreshProducts" />
        <button mat-raised-button color="primary" [routerLink]="['/product_input/0']">
          <mat-icon>add</mat-icon>
          Add Product
        </button>
      </div>
    </div>

    <!-- Status messages -->
    @if (success_msg()) {
      <div class="alert alert-green">
        <span>{{ success_msg() }}</span>
      </div>
    }
    @if (error_msg()) {
      <div class="alert alert-red">
        <span>{{ error_msg() }}</span>
      </div>
    }

    <!-- Filters -->
    <fh-filter-bar (resetFilters)="onResetFilters()">
      <!-- Country filter -->
      <fh-form-autocomplete
        [options]="countryOptions()"
        label="Country"
        placeholder="Select country..."
        appearance="outline"
        [formControl]="countryFilterFormControl"
        (selectionChange)="onCountryChange($any($event))"
      />

      <!-- Category filter -->
      <fh-form-autocomplete
        [options]="categoryOptions()"
        label="Category"
        placeholder="Select category..."
        [showCounts]="true"
        appearance="outline"
        [formControl]="categoryFilterFormControl"
        (selectionChange)="onCategoryChange($any($event))"
      />

      <!-- Search field -->
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search Products</mat-label>
        <input
          matInput
          [value]="searchText()"
          (input)="searchText.set($any($event.target).value)"
          (keyup.enter)="onSearchChange(searchText())"
          placeholder="Search by name, ID..."
        />
        <button matSuffix mat-icon-button (click)="onSearchChange(searchText())">
          <mat-icon>search</mat-icon>
        </button>
        @if (searchText()) {
          <button
            matSuffix
            mat-icon-button
            (click)="searchText.set(''); onSearchChange('')"
          >
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>
    </fh-filter-bar>

    <!-- Data Table -->
    <fh-data-table
      [config]="tableConfig()"
      [sortProp]="sortProp()"
      [sortDir]="sortDir()"
      [pageIndex]="pageIndex()"
      [pageSize]="pageSize()"
      [actions]="tableActions()"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
    />
  </div>
</div>

<!-- Expiry column template -->
<ng-template #expiryTemplate let-row>
  @if (row.expires_at) {
    <div
      [ngClass]="
        isProductExpired(row.expires_at)
          ? 'product-expiry-status--expired'
          : 'product-expiry-status--active'
      "
    >
      {{ row.expires_at | date: 'dd/MMM/yy, h:mm a' }}
      <button
        mat-icon-button
        [matTooltip]="'Reset expiry'"
        (click)="resetProductExpiry(row); $event.stopPropagation()"
      >
        <mat-icon class="expiry-restart-button">restart_alt</mat-icon>
      </button>
    </div>
  } @else {
    —
  }
</ng-template>
